import { useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { search } from 'store/mentorship/mentorship'
import MenteesPage from './Page'

export default function Mentees() {
  const dispatch = useDispatch()
  const list = useSelector(state => state.mentorship.mentorship.list)

  useEffect(() => {
    if (!list) dispatch(search())
  }, [dispatch, Boolean(list)])

  return (
    <Routes>
      <Route path="/*" element={<MenteesPage />} />
      <Route path="/:id" element={<MenteesPage />} />
    </Routes>
  )
}
